// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"243":"bce3c1cc","442":"22716ee1","825":"c5b80ac4","928":"f0c94cbd"}[chunkId] + ".js";
};